import React, { Fragment } from "react";

import ProductsContainer from "@common/product/ProductsContainer";

const AllProducts = () => {
  return (
    <Fragment>
      <ProductsContainer />
    </Fragment>
  );
};

export default AllProducts;
